import { render, staticRenderFns } from "./InvPL.vue?vue&type=template&id=aff7da94"
import script from "./InvPL.vue?vue&type=script&lang=js"
export * from "./InvPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports